module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../../node_modules/babel-loader/lib/index.js!./WithCreateTaopixProjectIntoCart.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/Common/Providers/WithCreateTaopixProjectIntoCart.js
// module id = 1299
// module chunks = 58